import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';
import { TypingActions } from './typing.actions';
import { UserInputActions } from '../user-input/user-input.actions';
import { Store } from '@ngrx/store';
import {
  selectIsConnected,
  selectPlatform,
} from '../live-chat/live-chat.reducer';
import { LiveChatPlatformService } from '../../services/live-chat/live-chat-platform.service';

@Injectable({
  providedIn: 'root',
})
export class TypingEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private liveChatPlatformService: LiveChatPlatformService
  ) {}

  // Listen to setTyping action & disable the user input field accordingly
  checkVaOrAgentTyping$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TypingActions.setVaTyping, TypingActions.setAgentTyping),
      switchMap((action) => {
        if (action.value) {
          return of(UserInputActions.disableUserInput());
        } else {
          return of(UserInputActions.enableUserInput());
        }
      })
    )
  );

  // Listen to setUserTyping action
  checkUserTyping$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TypingActions.markUserTyping),
      concatLatestFrom(() => [
        this.store.select(selectIsConnected),
        this.store.select(selectPlatform),
      ]),
      map(([action, isLiveChat, platform]) => {
        if (isLiveChat) {
          this.liveChatPlatformService
            .getPlatformService(platform)
            .setUserTyping(action.value);
        }
        return TypingActions.setUserTyping({ value: action.value });
      })
    )
  );
}
